dashboard.component('dashboard.dashboardComponent', {
    templateUrl: 'dashboard/dashboard.html',
    controller: 'dashboard.dashboardController'
});

dashboard.controller('dashboard.dashboardController', ['$scope', 'coreLanguage', '$state', 'coreFb', function($scope, $text, $state, $fb) {
    const $ctrl = this;
    $scope.$text = $text;

    $ctrl.$onInit = () => {
        $state.params.showGlobalLoading = false;
    }

    
}]);